import { inject, Injectable } from '@angular/core';
import { Notification, NotificationError, NotificationSuccess } from '../models';
import { ToasterService } from '@devinforius/i-essentials';

export type NotificationSeverity = 'success' | 'warn' | 'error' | 'info';

export interface NotificationOptions {
  life?: number;
  closable?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class Notifier {
  private readonly toaster = inject(ToasterService);

  public show(severity: NotificationSeverity, title: string, message: string, options?: NotificationOptions): void {
    const { life, closable = true } = options ?? {};
    this.toaster.push(severity, title, message, undefined, life ?? 5000, undefined, closable);
  }

  private extractConfigFromNotification(notification: Notification): {
    title: string;
    message: string;
    severity: NotificationSeverity;
  } {
    const { title, message, severity } = notification.config;
    return { title, message, severity };
  }

  public showError(error: NotificationError): void {
    const { title, message } = this.extractConfigFromNotification(error);
    this.show('error', title, message);
  }

  public showSuccess(success: NotificationSuccess): void {
    const { title, message } = this.extractConfigFromNotification(success);
    this.show('success', title, message);
  }

  public showInfo(info: Notification): void {
    const { title, message } = this.extractConfigFromNotification(info);
    this.show('info', title, message);
  }

  public showWarning(warning: Notification): void {
    const { title, message } = this.extractConfigFromNotification(warning);
    this.show('warn', title, message);
  }
}
